import { api } from './client';

export type NavMenuType = 'DIRECTORY' | 'MENU' | 'BUTTON' | 'EXTERNAL';
export type NavMenuStatus = 'NORMAL' | 'DISABLED';

export interface NavMenuNode {
  id: string;
  scope: 'PLATFORM' | 'TENANT';
  parentId: string | null;
  menuType: NavMenuType;
  sortOrder: number;
  title: string;
  iconKey: string | null;
  permissionCode: string | null;
  allowAllPlatformAdmins: boolean;
  path: string | null;
  componentPath: string | null;
  externalUrl: string | null;
  visible: boolean;
  status: NavMenuStatus;
  children: NavMenuNode[];
}

export const platformNavMenuApi = {
  getSidebar: () =>
    api.get<NavMenuNode[]>('/api/admin/nav-menus/sidebar').then((r) => r.data),

  getRoutePermissions: () =>
    api
      .get<Record<string, string | true>>('/api/admin/nav-menus/route-permissions')
      .then((r) => r.data),

  getTree: (scope: 'PLATFORM' | 'TENANT' = 'PLATFORM') =>
    api
      .get<NavMenuNode[]>('/api/admin/nav-menus/tree', { params: { scope } })
      .then((r) => r.data),

  create: (body: {
    scope: 'PLATFORM' | 'TENANT';
    parentId?: string | null;
    menuType: NavMenuType;
    sortOrder?: number;
    title: string;
    iconKey?: string | null;
    permissionCode?: string | null;
    allowAllPlatformAdmins?: boolean;
    path?: string | null;
    componentPath?: string | null;
    externalUrl?: string | null;
    visible?: boolean;
    status?: NavMenuStatus;
  }) => api.post<NavMenuNode>('/api/admin/nav-menus', body).then((r) => r.data),

  update: (
    id: string,
    body: {
      parentId?: string | null;
      menuType?: NavMenuType;
      sortOrder?: number;
      title?: string;
      iconKey?: string | null;
      permissionCode?: string | null;
      allowAllPlatformAdmins?: boolean;
      path?: string | null;
      componentPath?: string | null;
      externalUrl?: string | null;
      visible?: boolean;
      status?: NavMenuStatus;
    },
  ) =>
    api.patch<NavMenuNode>(`/api/admin/nav-menus/${id}`, body).then((r) => r.data),

  remove: (id: string) =>
    api.delete<{ success: boolean }>(`/api/admin/nav-menus/${id}`).then((r) => r.data),
};
